import _isBool from 'lodash/isBoolean'

/*
 * Determines the class name for the Optimizely feature case based on the variant.
 * @param {string} variant - The variant of the feature.
 * @returns {string} - The class name for the feature case.
 */
export function getClassName (variant) {
  return [
    'optimizely-feature-case',
    `optimizely-feature-case--${variant}`,
  ].join(' ')
}

/**
 * Determines if the feature should be rendered based on the provided props.
 * @param {Object} props - The properties to check.
 * @param {string} props.flag - The feature flag to check.
 * @param {string} props.variation - The variation to check against the current variation.
 * @param {boolean} props.isDefault - Whether the feature is a default variation.
 * @param {Object} props.optimizelyFeature - The Optimizely feature object.
 * @returns {boolean} - Returns true if the feature should be rendered, false otherwise.
 */
export function shouldRenderFeature (props) {
  const {
    flag,
    variation,
    isDefault,
    optimizelyFeature,
  } = props

  const currentVariation = optimizelyFeature.getIn(['flags', flag, 'variation'])
  const isEnabled = optimizelyFeature.getIn(['flags', flag, 'enabled'])
  const isMounted = optimizelyFeature.get('mounted', false)

  const isFallbackAllowed = isDefault && isEnabled === false
  const isMatchingVariation = isEnabled === true && variation === currentVariation

  return isMounted
  && _isBool(isEnabled)
  && (isMatchingVariation || isFallbackAllowed)
}
